export { default } from "./ContactForm";



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js